<script setup>
import { IonIcon } from "@ionic/vue";
import { closeCircle } from "ionicons/icons";
import { Dashboard } from "@uppy/vue";
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

const uploadData = defineModel();

const uppy = new Uppy({
	restrictions: {
		maxNumberOfFiles: 1,
		maxFileSize: 3000000,
		allowedFileTypes: ["image/*", ".pdf", ".eps", ".ai", ".svg"],
	},
	autoProceed: true,
})
	.use(XHRUpload, { endpoint: "/wp-json/product-builder/v1/logo/upload" })
	.on("complete", (res) => {
		if (res.successful && res.successful[0] && res.successful[0].response) {
			uploadData.value = res.successful[0].response.body;
		}
	});

const handleRemoveImage = () => {
	uploadData.value = null;
	uppy.clear();
};
</script>

<template>
	<template v-if="uploadData">
		<div class="c-card--upload u-p u-p-alt@ipad-pro">
			<div class="u-flex u-v-center u-space-between">
				<p class="e-heading e-heading--four e-heading--secondary">
					Your selected logo
				</p>
				<span
					class="e-link e-link--grey u-flex u-gap-quarter u-v-center"
					@click="handleRemoveImage()"
					>Remove <ion-icon class="u-font-large" :icon="closeCircle"
				/></span>
			</div>
			<img :src="uploadData" class="e-media u-width-1/2 u-mt-half" />
		</div>
	</template>

	<template v-else>
		<Dashboard :uppy="uppy" maxNumberOfFiles="1" class="e-uploader" />
	</template>
</template>
